export default __webpack_public_path__ + "assets/images/49ef03accfb36540089d601a4fbd57b3.png";